



// BellCurveChart.jsx
import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';

// Generate bell curve data (normal distribution)
const generateBellCurveData = (mean = 50, stdDev = 10, points = 100) => {
    const data = [];
    const step = (6 * stdDev) / points;

    for (let i = mean - 3 * stdDev; i <= mean + 3 * stdDev; i += step) {
        const x = i;
        const y =
            (1 / (stdDev * Math.sqrt(2 * Math.PI))) *
            Math.exp(-0.5 * Math.pow((x - mean) / stdDev, 2));
        data.push({ score: x.toFixed(2), frequency: (y * 1000).toFixed(2) }); // scale frequency
    }

    return data;
};

const data = generateBellCurveData(50, 10);

function BellCurveChart() {
    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    KPI/KRA Score Distribution (Bell Curve)
                </Typography>
                <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={data}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="score" label={{ value: 'Score', position: 'insideBottomRight', offset: -5 }} />
                        <YAxis label={{ value: 'Frequency', angle: -90, position: 'insideLeft' }} />
                        <Tooltip />
                        <Line type="monotone" dataKey="frequency" stroke="#8884d8" strokeWidth={2} dot={false} />
                    </LineChart>
                </ResponsiveContainer>
            </CardContent>
        </Card>
    );
}

export default BellCurveChart


